

export class Country {
    Id: string;
    Code: string;
    Description: string;
    Status: string;
    IsAgentMandatory: boolean;
    CanStudyAbroad: boolean;
    PhoneCode: number;
    IsDeleted: boolean;
}

export class LookupData {
    Code: string;
    Description: string;
}

class SchoolLookupData {
  Id: string;
  Name: string;
  GenderType: string;
  HasISP: boolean;
  HasStudyAbroad: boolean;
  SchoolSubType: any;
  SchoolLevel: any;
}

class RelationShipLookupData extends LookupData{
  IsDirectRelative: boolean;
}
export class RelationshipType {
  Code: string;
  Description: string;
  IsDirectRelative: boolean;
  IsHomestay: boolean;
  IsParent: boolean;
  IsParentNomination: boolean;
  IsSoftDeleted: boolean;
}

// export class Relationship {
//     Code: string;
//     Description: string;
//     IsSoftDeleted: boolean;
//     IsParent: boolean;
//     IsDirectRelative: boolean;
//     IsParentNomination: boolean;
//     IsHomestay: boolean;
// }

export interface SchoolCalendarTermDTO {
  Year: number;
  TermNumber: number;
  Weeks: number;
  StartDate: Date;
  EndDate: Date;
}

export type EnglishTestType = LookupData;
export type IecDuration = LookupData;
export type Relationship = RelationShipLookupData;
export type OHSCProvider = LookupData;
export type YearOfEntry = LookupData;
export type SchoolSubject = LookupData;
export type School = SchoolLookupData;
export type Term = LookupData;
export type SchoolDuration = LookupData;

export class VisaSubClass extends LookupData {
  VisaSubclassId: number;
  IsSoftDeleted: boolean;
}



export const BridgingVisas = [
    { Code: '010', Description: '010 Bridging (Class A)' },
    { Code: '020', Description: '020 Bridging (Class B)' },
    { Code: '030', Description: '030 Bridging (Class C)' },
    { Code: '040', Description: '040 Bridging (Class D - prospective app)' },
    { Code: '041', Description: '041 Bridging (Class D - non applicant)' },
    { Code: '050', Description: '050 Bridging (Class E - general)' },
    { Code: '051', Description: '051 Bridging (Class E - protection visa app)' },
    { Code: '060', Description: '060 Bridging (Class F)' },
    { Code: '070', Description: '070 Bridging (Class R - removal pending)' },
]

export const Tab_Title = {
  Dashboard_Title: 'Online Application Portal - DE International - Dashboard',
  Agent_Dashboard_Title: 'Online Application Portal - DE International - Dashboard - Agent',
  ImportantInformation_Title: 'Online Application Portal - DE International - Important Information',
  Agent_ImportantInformation_Title: 'Online Application Portal - DE International - Important Information - Agent',
  StudentDetails_Title: 'Online Application Portal - DE International - Student Details',
  Agent_StudentDetails_Title: 'Online Application Portal - DE International - Student Details - Agent',
  EnglishProficiency_Title: 'Online Application Portal - DE International - English Proficiency',
  Agent_EnglishProficiency_Title: 'Online Application Portal - DE International - English Proficiency - Agent',
  SchoolProgramAndPlacements_Title: 'Online Application Portal - DE International - School Program and Placements',
  Agent_SchoolProgramAndPlacements_Title: 'Online Application Portal - DE International - School Program and Placements - Agent',
  ParentCarerDetails_Title: 'Online Application Portal - DE International - Parent / Carer Details',
  Agent_ParentCarerDetails_Title: 'Online Application Portal - DE International - Parent / Carer Details - Agent',
  AccommodationAndWelfare_Title: 'Online Application Portal - DE International - Accommodation and welfare',
  Agent_AccommodationAndWelfare_Title: 'Online Application Portal - DE International - Accommodation and welfare - Agent',
  VisaAndOshcDetails_Title: 'Online Application Portal - DE International - Visa and OSHC Details',
  Agent_VisaAndOshcDetails_Title: 'Online Application Portal - DE International - Visa and OSHC Details - Agent',
  SpecialCircumstances_Title: 'Online Application Portal - DE International - Special Circumstances',
  Agent_SpecialCircumstances_Title: 'Online Application Portal - DE International - Special Circumstances - Agent',
  SupportingDocuments_Title: 'Online Application Portal - DE International - Supporting Documents',
  Agent_SupportingDocuments_Title: 'Online Application Portal - DE International - Supporting Documents - Agent',
  Summary_Title: 'Online Application Portal - DE International - Summary',
  Agent_Summary_Title: 'Online Application Portal - DE International - Summary - Agent',
  Payment_Title: 'Online Application Portal - DE International - Payment',
  Agent_Payment_Title: 'Online Application Portal - DE International - Payment - Agent',
  OAP_Print_Title: 'Online Application Portal - NSW Government Schools',
  Public_Payment_Title: 'Online Payment Portal - DE International',
}
